module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAAXNSR0IArs4c6QAAAJtJREFUOE9jZKABYMRm5v///yUZGBieEWFfIiMj4wJ0dbgMdWBgYNjPwMBwAI/BIDUNjIyMjaQa6sjIyIhh8P///2GWDnVD////H8rAwLAKR9iR5/3////XgwIcS6SAwo1iQ+EGIEXEgBiKLcllMyJ5nxyXYouKBkoNhadTlLRLoUtHDYUUKKNhiigOoWEBTsSwshObGHIqJ6QHADlBFeSG+UTIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/scene/tjs_sceneicon.png
// module id = Lf9H
// module chunks = 1